import React, { useState } from "react"
import UserContext from "./UserContext"

export const UserContextProvider = ({ children, initialOrgName, initialUser, signOut, initilisWhitelisted }) => {
  const [orgName, setOrgName] = useState(initialOrgName || null)
  const [user, setUser] = useState(initialUser || null)
  const [isWhitelisted, setIsWhitelisted] = useState(initilisWhitelisted || false)

  return (
    <UserContext.Provider value={{ orgName, setOrgName, user, setUser, signOut, isWhitelisted, setIsWhitelisted }}>
      {children}
    </UserContext.Provider>
  )
}